import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { Navbar, Container, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import "./Navbar.scss";

const MainNavbar = () => {
  return (
    <>
      <Navbar expand="md" className="mt-3" collapseOnSelect>
        <Container fluid>
          <NavLink className="ms-md-3" to="/">
            <Navbar.Brand>
              <svg
                width="120"
                height="37"
                viewBox="0 0 128 84"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.79272 81L64 4.98888L121.207 81H6.79272Z"
                  fill="#1C1C1C"
                  stroke="#00FFFF"
                  strokeWidth="6"
                />
                <path
                  d="M71.8001 57.56H57.2081L54.5201 65H49.9121L62.0081 31.736H67.0481L79.0961 65H74.4881L71.8001 57.56ZM70.5521 54.008L64.5041 37.112L58.4561 54.008H70.5521Z"
                  fill="#00FFFF"
                />
              </svg>
            </Navbar.Brand>
          </NavLink>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="navbar-toggler "
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto mb-1">
              <motion.li
                className="nav-item me-lg-3"
                initial={{ y: -30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5, ease: "linear", duration: 0.4 }}
              >
                <LinkContainer to="/">
                  <Nav.Link>
                    <NavLink
                      exact
                      activeClassName="menu-active"
                      className="nav-link navlink-border"
                      to="/"
                    >
                      Home
                    </NavLink>
                  </Nav.Link>
                </LinkContainer>
              </motion.li>

              <motion.li
                className="nav-item me-lg-3"
                initial={{ y: -30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.6, ease: "linear", duration: 0.5 }}
              >
                <LinkContainer to="/">
                  <Nav.Link>
                    <NavLink
                      exact
                      activeClassName="menu-active"
                      className="nav-link navlink-border"
                      to="/about"
                    >
                      About
                    </NavLink>
                  </Nav.Link>
                </LinkContainer>
              </motion.li>

              <motion.li
                className="nav-item me-lg-3"
                initial={{ y: -30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.7, ease: "linear", duration: 0.6 }}
              >
                <LinkContainer to="/">
                  <Nav.Link>
                    <NavLink
                      exact
                      activeClassName="menu-active"
                      className="nav-link navlink-border"
                      to="/projects"
                    >
                      Projects
                    </NavLink>
                  </Nav.Link>
                </LinkContainer>
              </motion.li>

              <motion.li
                className="nav-item me-lg-5"
                initial={{ y: -30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.8, ease: "linear", duration: 0.7 }}
              >
                <LinkContainer to="/">
                  <Nav.Link>
                    <NavLink
                      exact
                      activeClassName="menu-active"
                      className="nav-link navlink-border"
                      to="/contact"
                    >
                      Contact
                    </NavLink>
                  </Nav.Link>
                </LinkContainer>
              </motion.li>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default MainNavbar;
